import React from 'react';

import { Question } from '../Question';
import { Answers } from '../Answers';

import styles from './Settings.module.scss';

const Settings = ({ readOnly }: { readOnly: any }) => (
  <div className={styles.settings}>
    <Question readOnly={readOnly} />
    <div className={styles.divider} />
    <Answers />
  </div>
);

export default React.memo(Settings) as any;
